module.exports = __webpack_public_path__ + "static/img/wariant2.0b4788a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wariant2.jpg
// module id = HDyj
// module chunks = 1